import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { api } from '../services/api';
import { useAuth } from '../context/AuthContext';

export default function InvitePage() {
  const { token } = useParams();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [invite, setInvite] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [joining, setJoining] = useState(false);

  useEffect(() => {
    api.getInvite(token)
      .then(setInvite)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, [token]);

  const accept = async () => {
    if (!user) { navigate(`/auth?redirect=/invite/${token}`); return; }
    setJoining(true);
    try {
      await api.acceptInvite(token);
      navigate('/groups');
    } catch (err) {
      setError(err.message);
    } finally {
      setJoining(false);
    }
  };

  if (loading) return <div className="loading-screen">Loading invite…</div>;

  return (
    <div style={{ minHeight:'100vh', background:'#f4f1eb', display:'flex', alignItems:'center', justifyContent:'center', padding:'1rem' }}>
      <div style={{ width:'100%', maxWidth:400 }}>
        <div style={{ textAlign:'center', marginBottom:'1.5rem' }}>
          <h1 style={{ fontSize:24, color:'#0d2b1a', fontFamily:"'Playfair Display', serif" }}>
            Green<span style={{ color:'#2e7d4f' }}>time</span>
          </h1>
        </div>
        <div className="card" style={{ textAlign:'center' }}>
          {error ? (
            <>
              <div style={{ fontSize:32, marginBottom:8 }}>⚠️</div>
              <h3 style={{ marginBottom:8 }}>Invite not found</h3>
              <p style={{ fontSize:13, color:'#7a7a6a' }}>{error}</p>
              <button className="btn btn-accent btn-sm" style={{ marginTop:'1rem' }} onClick={() => navigate('/')}>Go to Greentime</button>
            </>
          ) : (
            <>
              <div style={{ width:48, height:48, borderRadius:12, background:invite.color,
                            display:'flex', alignItems:'center', justifyContent:'center',
                            fontSize:22, margin:'0 auto 0.75rem' }}>{invite.emoji}</div>
              <h3 style={{ marginBottom:4 }}>{invite.inviter_name} invited you</h3>
              <p style={{ fontSize:13, color:'#7a7a6a', marginBottom:'1.25rem' }}>
                Join <strong>{invite.group_name}</strong> on Greentime to share tee times with this group.
              </p>
              <button className="btn btn-accent" style={{ width:'100%', justifyContent:'center' }} onClick={accept} disabled={joining}>
                {joining ? 'Joining…' : user ? `Join ${invite.group_name}` : 'Sign in to accept'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
